import './index.css';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { useSelector } from 'react-redux'

import { IntlProvider } from 'react-intl'
import * as i18n from './i18n/translatedMessages/index.js';

import LessonDetailsContainer from './components/tailwind/LessonDetailsContainer';
import ErrorPage from './components/tailwind/ErrorPage';
import HomePage from './components/tailwind/HomePage';
import TranscriptsPage from './components/tailwind/TranscriptsPage.jsx';
import UpdatesPage from './components/tailwind/UpdatesPage.jsx';
import TermsConditionsPage from './components/tailwind/TermsConditionsPage.jsx';
import SupportFaqPage from './components/tailwind/SupportFaqPage.jsx';


function App() {

  //const dispatch = useDispatch();
  const module = useSelector((state) => state.module)
  const viewer = useSelector((state) => state.viewer)

  //Go with the language set in the module unless the user overides. 
  let locale = "en_EN";

  if (viewer.language.locale === "auto") {
    if (typeof module.metadata.locale !== 'undefined') {
      locale = module.metadata.locale;
    }
  } else {
    locale = viewer.language.locale;
  }

  var messages = i18n[locale];
  var localeWithoutRegionCode;
  if (locale !== null) {
    localeWithoutRegionCode = locale.split(/[_-]+/)[0];
  }
  else {
    localeWithoutRegionCode = "EN"
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: <HomePage page="home" />,
      errorElement: <ErrorPage />
    },
    {
      path: "/help",
      element: <SupportFaqPage />,
      errorElement: <ErrorPage />
    },
    {
      path: "/support",
      element: <SupportFaqPage />,
      errorElement: <ErrorPage />
    },
    {
      path: "/transcripts",
      element: <TranscriptsPage tabKey="/lessons" />,
      errorElement: <ErrorPage />
    },
    {
      path: "/legal",
      element: <TermsConditionsPage />,
      errorElement: <ErrorPage />
    },
    {
      path: "/updates",
      element: <UpdatesPage />,
      errorElement: <ErrorPage />
    },
    {
      path: "/lessons/:id",
      element: <LessonDetailsContainer />,
      errorElement: <ErrorPage />
    },
    {
      path: "/lesson/:id",
      element: <LessonDetailsContainer />,
      errorElement: <ErrorPage />
    }
  ], {
    basename: (process.env.PUBLIC_URL || '').replace(/\/+$/, '') || '/', //This is set in package.json "homepage": "https://www.meted.ucar.edu/etc/etc"
  });

  return (
    <IntlProvider key="intl" locale={localeWithoutRegionCode} messages={messages} >
      <RouterProvider router={router} />
    </IntlProvider>
  );

}

export default App;